import { HeroDiagram } from "./HeroDiagram";
import { Eyebrow } from "./SectionHeader";
import type { Theme } from "./theme";

export function HeroFull({ theme }: { theme: Theme }) {
  return (
    <section style={{ padding: "96px 40px 80px", position: "relative", overflow: "hidden" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative" }}>
        <Eyebrow theme={theme}>Hiring decision intelligence</Eyebrow>
        <h1
          style={{
            fontSize: "clamp(48px, 6.2vw, 88px)",
            lineHeight: 0.98,
            letterSpacing: "-2.2px",
            fontWeight: 600,
            margin: "20px 0 28px",
            color: theme.fg,
            maxWidth: 960,
            textWrap: "balance",
          }}
        >
          Hire like an executive search firm.
        </h1>
        <p
          style={{
            fontSize: 20,
            lineHeight: 1.45,
            color: theme.fgMute,
            maxWidth: 620,
            margin: "0 0 18px",
            letterSpacing: "-0.2px",
          }}
        >
          AI where it helps. Human judgement where it matters.
        </p>
        <p
          style={{
            fontSize: 17,
            lineHeight: 1.55,
            color: theme.fgMute,
            maxWidth: 620,
            margin: "0 0 40px",
          }}
        >
          Rarion is a collaborative decision-quality system for hiring, combining executive search
          methodology, occupational psychology, and structured, evidence-based evaluation.
        </p>

        <div
          style={{
            display: "flex",
            gap: 8,
            fontSize: 13,
            color: theme.fgMute,
            letterSpacing: 0.3,
            textTransform: "uppercase",
            fontWeight: 500,
          }}
        >
          <span>A collaborative system</span>
          <span style={{ opacity: 0.4 }}>·</span>
          <span>AI-accelerated</span>
          <span style={{ opacity: 0.4 }}>·</span>
          <span>Human-led</span>
        </div>
      </div>

      <div style={{ maxWidth: 1200, margin: "80px auto 0" }}>
        <HeroDiagram theme={theme} />
      </div>
    </section>
  );
}
